import Head from './TopHead';
import Curric from './Curric';

function Sheets() {
    return (
        <main>
            <Head />

            <h1>Google Sheets</h1>

            <section className="section">
                <h2>Google Sheets Fundamental Skills: 6 Levels</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Level 1 - Introduction - Learn Basics (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to perform everyday office tasks in Google Sheets, create
                            spreadsheets with basic formulas, organize and filter data.
                        </div>
                        <ul>
                            <li>Format, Layout & Design New Spreadsheets</li>
                            <li>Merged Cells</li>
                            <li>Basic Conditional Formatting</li>
                            <li>Build Basic Dropdown Selections in Cells</li>
                            <li>Basic Formulas</li>
                            <li>The FILL Handle</li>
                            <li>Absolute & Relative References</li>
                            <li>Calculations: Formulas and Functions (SUM, AVERAGE, COUNT, COUNTA, MAX, MIN)</li>
                            <li>Sorting & Filtering Data</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic computer skills, including saving and
                            locating files, and proficiency with a basic calculator.</div>
                    </Curric>

                    <Curric title="Level 2 - Intermediate (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to interlink data between sheets, and create more
                            complex spreadheets that automatically update with newly added data.
                        </div>
                        <ul>
                            <li>Function Syntax & Multiple Arguments</li>
                            <li>TODAY function</li>
                            <li>Creating Formulas From Other Sheets</li>
                            <li>Creating Formulas From Other Spreadsheets</li>
                            <li>IMPORTRANGE function</li>
                            <li>Table Objects</li>
                            <li>Remove Duplicates</li>
                            <li>SUMIFS, AVERAGEIFS & COUNTIFS functions</li>
                            <li>CONCATENATE</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Familiarity with Google Sheets's interface and the ability
                            to manually write basic formulas instead of solely relying on built-in buttons. Have some
                            understanding of absolute vs relative references (A1 vs $A$1).</div>
                    </Curric>

                    <Curric title="Level 3 - InterPLUS - Data Analysis (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to work with data with 1,000s of lines, summarize it,
                            pull related data from other sheets and make some basic charts.
                        </div>
                        <ul>
                            <li>Pivot Tables</li>
                            <li>XLOOKUP & VLOOKUP</li>
                            <li>Merge Data with Lookup Functions</li>
                            <li>Shortcuts for Managing Large Datasets</li>
                            <li>Build Reports from Large Datasets</li>
                            <li>Create Basic Charts</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must know how to create formulas that link to data
                            located on other sheets, and be familiar with filters.</div>
                    </Curric>


                    <Curric title="Level 4  - Advanced (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to create complex nested formulas using multiple
                            functions and gain in-depth understanding of data types.
                        </div>
                        <ul>
                            <li>Logical Test</li>
                            <li>AND OR Functions</li>
                            <li>ISNUMBER, ISBLANK Functions</li>
                            <li>ROUND, ROUNUP, ROUNDDOWN functions</li>
                            <li>Nested formulas & functions</li>
                            <li>IF & IFS Functions</li>
                            <li>Working with Dates</li>
                            <li>DATE function</li>
                            <li>ISNUMBER, XMATCH</li>
                            <li>Compare Two Tables for Matching Records</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be comfortable with formula syntax, be
                            familiar with VLOOKUP or XLOOKUP.</div>
                    </Curric>

                    <Curric title="Level 5 - AdvancedPLUS (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to do advanced level tasks & build basic array formulas to create auto-populating formula columns.
                        </div>
                        <ul>
                            <li>Advanced Conditional Formatting with Formulas</li>
                            <li>Conditional Formatting Duplicates</li>
                            <li>DATEDIF, NETWORKDAYS.INTL</li>
                            <li>INDEX, XMATCH - 2 way lookups </li>
                            <li>ARRAYFORMULA</li>
                            <li>Auto-populating formulas with ARRAYFORMULA</li>
                            <li>UNIQUE, SORT</li>
                            <li>FILTER function</li>
                            <li>Lookup with Multiple Matches with FILTER</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be comfortable with IF statements and logical tests.</div>
                    </Curric>

                    <Curric title="Level 6 - Power User (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> You'll learn how to write SQL like queries with QUERY function, do complex text operations using regular expressions, create new worksheet functions with LAMBDA and much more!
                        </div>
                        <ul>
                            <li>QUERY function</li>
                            <li>LAMBDA function</li>
                            <li>Create new functions in worksheets</li>
                            <li>REGEXEXTRACT, REGEXREPLACE, REGEXMATCH</li>
                            <li>LET function</li>
                            <li>MAP, BYROW, REDUCE</li>
                            <li>CHOOSEROWS, CHOOSECOLS</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> This course is only suitable for very advanced users.</div>
                    </Curric>
                </div>
            </section>

            <hr />

            <section className="section">
                <h2>Automating Google Sheets with Apps Script</h2>
                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Google Apps Script Level 1: Introduction to Apps Script and Your First Script (3 Hours)">
                        <ul>
                            <li>Welcome and course overview; accessing the Script Editor (<code>Tools</code> &gt; <code>Script editor</code>) and understanding the IDE.</li>
                            <li>JavaScript fundamentals: variables, functions, data types, and using <code>Logger.log()</code> or <code>console.log()</code> for output.</li>
                            <li>Interacting with Sheets: understanding the <code>SpreadsheetApp</code> service, object hierarchy, and methods like <code>getActiveSpreadsheet()</code>, <code>getActiveSheet()</code>, <code>getRange()</code>, <code>getValue()</code>, and <code>setValue()</code>.</li>
                            <li>Recording Macros.</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must be intermediate plus Google Sheets user.</div>
                    </Curric>

                    <Curric title="Google Apps Script Level 2: Enhancing Automation and User Interaction (4 Hours)">
                        <ul>
                            <li>Control Flow: Implementing conditional statements (<code>if/else</code>) and loops (<code>for</code>, <code>forEach</code>) for processing lists of data.</li>
                            <li>Custom Menus and Triggers: Utilizing the <code>onOpen</code> simple trigger and creating custom menus with <code>createMenu()</code> to run scripts from the UI.</li>
                            <li>Debugging: Using the built-in debugger with breakpoints and interpreting execution logs.</li>
                        </ul>
                    </Curric>

                    <Curric title="Google Apps Script Level 3: Working with 2D Data Arrays and Efficiency (4 Hours)">
                        <ul>
                            <li>Efficient Range Handling: Working with entire datasets using <code>getValues()</code> and <code>setValues()</code> (2D arrays) to minimize calls to the API.</li>
                            <li>Working with Multiple Sheets: Using <code>getSheetByName()</code> to manage data flow between different tabs (e.g., Staging to Processed).</li>
                            <li>Error Handling: Implementing <code>try...catch</code> blocks for robust error management and basic data validation within scripts.</li>
                        </ul>
                    </Curric>

                    <Curric title="Google Apps Script Level 4: Advanced Automation and External Services (3 Hours)">
                        <ul>
                            <li>Scheduled Triggers: Setting up time-driven triggers via the Triggers dashboard for automated, recurring tasks.</li>
                            <li>Interacting with Other Google Services: Using the <code>GmailApp</code> or <code>MailApp</code> services to send automated emails based on sheet data.</li>
                            <li>External APIs and Libraries: Brief overview of fetching data with <code>UrlFetchApp</code> and using Apps Script Libraries.</li>
                        </ul>
                    </Curric>



                </div>
            </section>


            <hr />

            <section className="section">
                <h2>Google Data Studio (Looker Studio) - Data Visualization</h2>
                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>


                    <Curric title="Looker Studio Level 1 - Connecting Data and Building Your First Report (3 Hours)">
                        <ul>
                            <li>Welcome, course overview, and introduction to Google Data Studio (now Looker Studio).</li>
                            <li>Understanding the interface: navigation, report editor, view mode.</li>
                            <li>Connecting data sources: linking Google Sheets and BigQuery as primary sources.</li>
                            <li>Configuring data source fields: setting correct data types (dimensions vs. metrics), aggregation methods, and naming conventions.</li>
                            <li>Building basic visualizations: adding scorecards, tables, and simple bar charts.</li>
                            <li>Styling and theming: applying basic color palettes and layouts for a professional look.</li>
                        </ul>
                    </Curric>

                    <Curric title="Looker Studio Level 2 - Enhancing Interactivity and Advanced Visualizations (3 Hours)">
                        <ul>
                            <li>Adding interactivity: using filters, date range controls, and dimension filters to explore data dynamically.</li>
                            <li>Advanced visualizations: creating time series charts, pie charts, geo maps, and blended data tables.</li>
                            <li>Calculated fields: writing basic formulas within Data Studio to derive new metrics (e.g., profit margin, percentage of total).</li>
                            <li>Data blending: combining data from different sources or sheets on a common key (e.g., date or ID).</li>
                        </ul>
                    </Curric>

                    <Curric title="Looker Studio Level 3 - Sharing, Collaboration, and Advanced Techniques (3 Hours)">
                        <ul>
                            <li>Using functions in Data Studio.</li>
                            <li>Applying built-in functions for text manipulation, date calculations, and logical operations within calculated fields.</li>
                            <li>Sharing and collaboration: setting viewing permissions, sharing links, and scheduling email delivery of reports.</li>
                            <li>Report efficiency and optimization: understanding data freshness and how to improve report speed.</li>
                            <li>Data governance: understanding how data sources are managed and reused across an organization.</li>
                        </ul>
                    </Curric>

                </div>
            </section>

        </main>

    );
}

export default Sheets;